import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  viewBox: "0 0 699.2 740"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "m674.1 519.7 25.1-396.4L432.6 0zM532 636l-37.1-89.9H204.3L167.2 636l182.4 104zM445.2 429.5l-95.6-232.3-95.5 232.3zM0 123.3l25.1 396.4L266.6 0z" }, null, -1)
  ])))
}
export default { render: render }